import React, { useEffect } from "react";
import ReactApexChart from "react-apexcharts";

const PieChart = ({ loanStatsData }) => {
  useEffect(() => {
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    },0);

    return () => {
      window.dispatchEvent(new Event("resize"));
    };
  }, []);

  if (!loanStatsData) {
    return null;
  }

  const {
    bank_approved_loans,
    beythak_approved_loans,
    pending_loans,
    beythak_rejected_loans,
    bank_rejected_loans,
    bank_not_reviewed,
  } = loanStatsData;

  const series = [
    bank_approved_loans,
    beythak_approved_loans,
    pending_loans,
    beythak_rejected_loans,
    bank_rejected_loans,
    bank_not_reviewed,
  ];
  const labels = [
    "Bank Approved Loans",
    "Beythak Approved Loans",
    "Pending Loans",
    "Beythak Rejected Loans",
    "Bank Rejected Loans",
    "Bank Not Reviewed",
  ];

  const options = {
    labels: labels,
    colors: ["#18a07a", "#29aac5", "#f29d41", "#d84848", "#d84848", "#727272"],
    responsive: [
      {
        breakpoint: 5000,
        options: {
          chart: {
            height: 230,
            width: "100%",
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
        },
      },
      {
        breakpoint: 1700,
        options: {
          chart: {
            height: 160,
            width: "100%",
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
        },
      },
      {
        breakpoint: 1450,
        options: {
          chart: {
            height: 130,
            width: "100%",
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
        },
      },
      {
        breakpoint: 1290,
        options: {
          chart: {
            height: 100,
            width: "100%",
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
        },
      },
      {
        breakpoint: 1200,
        options: {
          chart: {
            height: 250,
            width: "100%",
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
        },
      },
      {
        breakpoint: 440,
        options: {
          chart: {
            height: 200,
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
        },
      },
    ],
  };

  return (
    <React.Fragment>
      <ReactApexChart height={250} options={options} series={series} type="pie" />
    </React.Fragment>
  );
};

export default PieChart;
